import { useState, useEffect } from 'react';
import filtersModel from '../../filters.model';
import { PerfilUsuarioService } from '../../services/PerfilUsuarioService';

export default (props) => {
  const { paginationFilters, cleanFilters } = filtersModel();

  const [selectPerfil, setSelectPerfil] = useState();

  const getDataPerfilOptions = async () => {
    const response = await PerfilUsuarioService.findAllPerfil(
      `?page=${paginationFilters.page}&linesPerPage=${
        paginationFilters.linesPerPage
      }&orderBy=${paginationFilters.orderBy}&direction=${
        paginationFilters.direction ? 'ASC' : 'DESC'
      }`,
      {
        ...cleanFilters(),
      }
    );
    setSelectPerfil(response);
  };

  useEffect(() => {
    getDataPerfilOptions();

    // eslint-disable-next-line
  }, []);

  return {
    selectPerfil,
  };
};
